import {
  mapPaginationType,
  mapVenueShowType,
  useFindAllVenueShows,
} from '@api';
import {
  getTableParams,
  ManageTableProvider,
  useManageTable,
  VenueShowsTable,
} from '@common';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/venues/$id.shows';

export const VenueUnconfirmedShows: React.FC = () => {
  const { t } = useTranslation('venueDetailsShows');
  const { id } = Route.useParams();
  const searchParams = Route.useSearch();
  const { tableIdUnconfirmed: tableId } = Route.useRouteContext();

  const tableParams = getTableParams(searchParams, tableId);

  const { data, isFetching } = useFindAllVenueShows(
    id,
    {
      type: 'UNCONFIRMED',
      ...tableParams,
    },
    {
      query: {
        select: (response) => ({
          shows: response.data.map(mapVenueShowType),
          pagination: mapPaginationType(response.metadata.pagination),
        }),
      },
    }
  );

  const shows = data?.shows ?? [];
  const pagination = data?.pagination ?? mapPaginationType(undefined);

  const methods = useManageTable({
    navigateFn: Route.useNavigate(),
    searchParams,
    pagination,
    config: {},
    tableId,
  });

  return (
    <ManageTableProvider {...methods}>
      <VenueShowsTable
        title={t('VENUE_UNCONFIRMED_SHOWS.TITLE')}
        shows={shows}
        isFetching={isFetching}
        dataTestId="venue-unconfirmed-shows-container"
      />
    </ManageTableProvider>
  );
};
